import { useEffect, useState } from 'react';
import { useFullyReadMarkerStore } from '../../store/use-fully-read-marker-store';
import isEqual from 'lodash/isEqual';
export function useDMUnreads(casablancaClient, dmIds, ignoreThreads = true) {
    const [state, setState] = useState({ dmUnreadChannelIds: new Set() });
    useEffect(() => {
        if (!casablancaClient) {
            return;
        }
        const updateUnread = () => {
            const unreadChannelIds = new Set();
            const markers = useFullyReadMarkerStore.getState().markers;
            const channelIds = new Set([...dmIds.map((dm) => dm.id)]);
            Object.values(markers).forEach((marker) => {
                if (marker.isUnread &&
                    channelIds.has(marker.channelId) &&
                    (!ignoreThreads || !marker.threadParentId)) {
                    unreadChannelIds.add(marker.channelId);
                }
            });
            setState((prev) => {
                if (isEqual(prev.dmUnreadChannelIds, unreadChannelIds)) {
                    return prev;
                }
                return { dmUnreadChannelIds: unreadChannelIds };
            });
        };
        updateUnread();
        const unsubscribe = useFullyReadMarkerStore.subscribe(updateUnread);
        return () => {
            unsubscribe();
        };
    }, [casablancaClient, setState, dmIds, ignoreThreads]);
    return state;
}
//# sourceMappingURL=useDMUnreads.js.map